<template>
    <div :id="id" class="sidebar">
        <main class="sidebar-content">
            <button class="btn btn-flat sidebar-close" @click.prevent="close">
                <i class="fas fa-times"></i>
            </button>
            <header class="sidebar-header">
                <h3 class="sidebar-title">{{ title }}</h3>
            </header>
            <section>
                <slot class="sidebar-body" />
            </section>
        </main>
        <div class="sidebar-overlay" @click.prevent="close"></div>
    </div>
</template>
<script>
export default {
    props: {
        id: {
            type: String,
            default: 'sidebar'
        },
        show: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Sidebar title',
        },
    },
    watch: {
        show: {
            immediate: true,
            handler(show) {
                show ? this.open() : this.close();
            },
        },
    },
    methods: {
        open() {
            this.$emit('beforeOpen');
            $(`#${this.id}.sidebar`).addClass('active');
            $(`#${this.id} .sidebar-overlay`).addClass('active');
            $('a[aria-expanded=true]').attr('aria-expanded', 'false');
            this.$emit('afterOpen');
        },
        close() {
            this.$emit('beforeClose');
            $(`#${this.id}.sidebar`).removeClass('active');
            $(`#${this.id} .sidebar-overlay`).removeClass('active');
            this.$emit('afterClose');
        },
    },
};
</script>
